<template>
	<div class="w-100">
		<v-alert type="error" class="w-100 mb-2" variant="tonal" v-if="error">
			{{ error }}
		</v-alert>

		<v-row class="w-100 mx-0 mt-0 mb-10 pa-0">
			<v-col cols="12" md="3" class="flex-start flex-column px-0 pr-md-2">
				<p class="w-100 text-left mb-2">Filter By</p>
				<v-card class="w-100 elevation-1 rounded-1 pa-3 flex-center flex-column">
					<div class="w-100 flex-center flex-column">
						<template v-if="categories.length > 0">
							<v-checkbox
								class="w-100 text-left"
								color="#958FC5"
								hide-details
								v-for="category in categories"
								:key="category.id"
								v-model="selectedCategories"
								:value="category.id"
								:label="category.name" />
						</template>
						<template v-else>
							<p class="w-100 text-disabled text-left pa-2">No categories found.</p>
						</template>
					</div>
				</v-card>
			</v-col>
			<v-col cols="12" md="9" class="flex-start flex-column px-0">
				<p class="w-100 text-right mb-8"></p>

				<div class="w-100 flex-center flex-column">
					<template v-if="filteredTypes.length > 0">
						<v-row class="w-100 ma-0 pa-0">
							<v-col
								cols="12"
								sm="6"
								md="6"
								lg="4"
								class="pt-0 px-0 pl-md-5"
								v-for="type in filteredTypes.slice(0, visibleCount)"
								:key="`tool-${type.id}`">
								<v-card
									:href="`/${type.slug}`"
									class="w-100 elevation-1 rounded-1 h-100 d-flex flex-column">
									<div class="w-100 d-flex align-center justify-start py-5 px-5">
										<div
											class="dash-icon-wrap flex-center pa-3 mr-4"
											style="
												background-color: #0e081820;
												border-radius: 4px;
												width: 38px;
												height: 38px;
											">
											<v-icon size="20" color="#0e0818">
												{{ type.icon }}
											</v-icon>
										</div>

										<h5
											style="max-width: 75%"
											class="medium-text text-high-emphasis font-weight-medium">
											{{ type.name }}
										</h5>
									</div>

									<div class="w-100 px-5 flex-start" style="flex-wrap: wrap">
										<v-chip
											v-for="tag in type.doc_type_categories.slice(0, 2)"
											:key="`tag-${tag.id}`"
											class="rounded-1 mr-2 mb-2"
											:color="tag.color"
											size="small">
											{{ tag.name }}
										</v-chip>

										<span
											class="small-text text-disabled"
											v-if="type.doc_type_categories.length > 2">
											+{{ type.doc_type_categories.length - 2 }}
										</span>
									</div>

									<v-card-text class="px-5 text-medium-emphasis py-2">
										{{ type.description.slice(0, 80) }}
										{{ type.description.length > 80 ? "..." : "" }}
									</v-card-text>

									<v-spacer></v-spacer>

									<v-card-actions class="px-5 pt-0">
										<a class="dark-back-link" :href="`/${type.slug}`">
											Try for Free
											<v-icon class="ml-2">mdi-chevron-right</v-icon>
										</a>
									</v-card-actions>
								</v-card>
							</v-col>
						</v-row>

						<!-- Show More / Show Less Controls -->
						<div class="w-100 d-flex align-center justify-start" v-if="filteredTypes.length > 15">
							<v-btn
								variant="plain"
								class="normal-spacing ml-1"
								style="text-transform: none !important"
								v-if="filteredTypes.length > visibleCount"
								@click="showMore">
								Show More
							</v-btn>
							<v-btn
								variant="plain"
								class="normal-spacing px-1"
								v-if="visibleCount > 15"
								@click="showLess">
								Show Less
							</v-btn>
						</div>
					</template>
					<template v-else>
						<p class="w-100 text-disabled text-left px-md-6">No tools found.</p>
					</template>
				</div>
			</v-col>
		</v-row>
	</div>
</template>

<script>
	import { ref, computed, watch } from "vue"

	export default {
		props: {
			categories: {
				type: Array,
				default: () => [],
			},
		},
		setup(props) {
			const error = ref(null)
			const selectedCategories = ref([])

			// Show More / Show Less control
			const visibleCount = ref(15)

			const showMore = () => {
				visibleCount.value += 15
			}

			const showLess = () => {
				visibleCount.value = 15
			}

			// Gather and deduplicate docTypes from all categories:
			function gatherAllDocTypes() {
				const seen = new Set()
				const allTypes = []

				const relevantCategories = selectedCategories.value.length
					? props.categories.filter((cat) => selectedCategories.value.includes(cat.id))
					: props.categories

				for (const cat of relevantCategories) {
					for (const dt of cat.doc_types) {
						if (!seen.has(dt.id)) {
							seen.add(dt.id)
							allTypes.push(dt)
						}
					}
				}

				return allTypes
			}

			const filteredTypes = computed(() => {
				let allTypes = gatherAllDocTypes()

				return allTypes
			})

			// Reset to 15 whenever user changes filters or search
			watch([selectedCategories], () => {
				visibleCount.value = 15
			})

			return {
				error,
				selectedCategories,
				filteredTypes,
				visibleCount,
				showMore,
				showLess,
			}
		},
	}
</script>
